import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Button } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { WorkHistoryExpandRolesButtonProps as Props } from './types';

export const WorkHistoryExpandRolesButton = memo(
  ({ className, items, state }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('WorkHistoryExpandRolesButton', className)}
        sx={SX.root}
      >
        {items.length > 1 && (
          <Button
            variant="outlined"
            color="default"
            size="xsmall"
            endIcon={
              <Icon name={state.value ? 'chevron-up' : 'chevron-down'} />
            }
            onClick={() => (state.value ? state.onFalse() : state.onTrue())}
          >
            {`${items.length} Roles`}
          </Button>
        )}
      </Styled.Wrapper>
    );
  }
);

WorkHistoryExpandRolesButton.displayName = 'WorkHistoryExpandRolesButton';
